import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import permission from './modules/permission';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    permission: permission,
    settings: settings,
    user: user
  },
  getters: getters
});
export default store;